import { render, staticRenderFns } from "./RadarCard.vue?vue&type=template&id=44d9d6b8&"
import script from "./RadarCard.vue?vue&type=script&lang=js&"
export * from "./RadarCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports